// extracted by mini-css-extract-plugin
export default {"header":"mHYdXVygvFnivZ4FWC7K","back":"ZhRWky6E2YJRio95WXH_","wrapper":"NTaPCBelEiGAsWsA0x0_","body":"ez3oeMRBFCFinNfUOwdb"};